import { Select, SelectProps, Form } from "antd";
import { useEffect, useMemo } from "react";

import {
  unitDN,
  unitNB,
  unitTSN,
  departments,
  DepartmentCode,
} from "../../../constants";
import { StringHelper } from "../../../helper";

interface Props extends SelectProps {
  fieldName?: string;
  fieldDepartmentName?: string;
}

const unitOptionsByDepartment: any = {
  [DepartmentCode.TSN]: unitTSN,
  [DepartmentCode.NB]: unitNB,
  [DepartmentCode.DN]: unitDN,
};

export const getUnitOptions = (departmentCode: DepartmentCode) => {
  if (!departmentCode) return [];
  if (unitOptionsByDepartment[departmentCode]) {
    return unitOptionsByDepartment[departmentCode];
  }
  return [departments.find((e) => e.value.startsWith(departmentCode))];
};

export const UnitSelect = ({
  fieldName = "eUnit",
  fieldDepartmentName = "eDepartment",
  ...restProps
}: Props) => {
  const form = Form.useFormInstance();

  const eDepartment = Form.useWatch(fieldDepartmentName, form);
  const departmentCode =
    StringHelper.verticalBarSplit<[DepartmentCode]>(eDepartment)[0];

  const unitOptions: SelectProps["options"] = useMemo(
    () => getUnitOptions(departmentCode),
    [departmentCode]
  );

  useEffect(() => {
    if (unitOptions?.length === 1) {
      form.setFieldValue("eUnit", unitOptions[0].value);
    } else {
      form.setFieldValue("eUnit", null);
    }
  }, [form, unitOptions]);

  return <Select {...restProps} options={unitOptions} />;
};
